import ApiCrud from "./api-crud";
import apiCaller from "./api-caller";

class HoraService extends ApiCrud {
  resource = "horas";
  primaryKey = "idhora";

  exportarCSV(params) {
    return apiCaller
      .get(`/${this.resource}/exportar-csv`, { params })
      .then((response) => {
        return response.data;
      });
  }
}

export default new HoraService();
